/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VesselNextPort } from './VesselNextPort';
import {
    VesselNextPortFromJSON,
    VesselNextPortFromJSONTyped,
    VesselNextPortToJSON,
} from './VesselNextPort';

/**
 * 
 * @export
 * @interface VesselPredictionsResult
 */
export interface VesselPredictionsResult {
    /**
     * 
     * @type {VesselNextPort}
     * @memberof VesselPredictionsResult
     */
    nextPort?: VesselNextPort;
}

/**
 * Check if a given object implements the VesselPredictionsResult interface.
 */
export function instanceOfVesselPredictionsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VesselPredictionsResultFromJSON(json: any): VesselPredictionsResult {
    return VesselPredictionsResultFromJSONTyped(json, false);
}

export function VesselPredictionsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): VesselPredictionsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextPort': !exists(json, 'next_port') ? undefined : VesselNextPortFromJSON(json['next_port']),
    };
}

export function VesselPredictionsResultToJSON(value?: VesselPredictionsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'next_port': VesselNextPortToJSON(value.nextPort),
    };
}

